/* Zenmen standalone pages — behavior for the six page.zen-* templates.
   Each block below no-ops when its markup is absent, so one file serves all six
   views and a removed section never throws. */
(function () {
  'use strict';



  /* ---------------------------------------------------------------------
     Money. Implements Shopify's four money_format placeholders properly
     rather than regex-stripping digits to guess a symbol, which is what
     broke on trailing-symbol and comma-separator locales.
     --------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    function group(num, decimals, thousands, decimal) {
      if (isNaN(num) || num === null) { return '0'; }
      var value = (num / 100).toFixed(decimals);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  function init(context) {
    var roots = context.querySelectorAll('.zen-page');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__zenPagesWired) return; root.__zenPagesWired = true;
      initIngredientSearch(root); initLotLookup(root); initBuilder(root);
    });
  }
  window.zpInitPages = init;
  init(document);
  document.addEventListener('shopify:section:load', function () { init(document); });
  document.addEventListener('brand:defer:open', function () { init(document); });

  /* ---------------------------------------------------------------------
     Ingredient explorer: filter cards on the pre-rendered data-search blob.
     Server-rendered first, so the full list is in the HTML for crawlers and
     for anyone with JS off; the field only ever hides rows.
     --------------------------------------------------------------------- */
  function initIngredientSearch(root) {
    var input = root.querySelector('[data-zpg-ing-search]');
    var grid = root.querySelector('[data-zpg-ing-grid]');
    if (!input || !grid) { return; }

    var cards = grid.querySelectorAll('[data-zpg-ing]');
    var countEl = root.querySelector('[data-zpg-ing-count]');
    var emptyEl = root.querySelector('[data-zpg-ing-empty]');
    var total = cards.length;

    function apply() {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      Array.prototype.forEach.call(cards, function (card) {
        var hay = card.getAttribute('data-search') || '';
        var hit = !q || hay.indexOf(q) > -1;
        card.hidden = !hit;
        if (hit) { shown++; }
      });
      if (countEl) {
        countEl.textContent = q
          ? shown + ' of ' + total + ' ingredients'
          : total + ' ingredients';
      }
      if (emptyEl) { emptyEl.hidden = shown !== 0; }
    }

    input.addEventListener('input', apply);
    apply();
  }

  /* ---------------------------------------------------------------------
     Lot lookup. Searches only the lot numbers actually published on products.
     There is no "verified" state for an unknown string: an unmatched lot gets
     an honest miss, which is the whole reason this page exists.
     --------------------------------------------------------------------- */
  function initLotLookup(root) {
    var input = root.querySelector('[data-zpg-lot-input]');
    var btn = root.querySelector('[data-zpg-lot-btn]');
    var out = root.querySelector('[data-zpg-lot-result]');
    var dataEl = root.querySelector('[data-zpg-lot-data]');
    if (!input || !btn || !out) { return; }

    var lots = [];
    if (dataEl) {
      try { lots = JSON.parse(dataEl.textContent) || []; } catch (err) { lots = []; }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* The certificate card the scan overlay plays over: light layout uses
       .bt-coa, the Zenmen dark panel uses .bt-panel. */
    var card = root.querySelector('.bt-coa') || root.querySelector('.bt-panel');
    var SCAN_MS = 1100;
    var reduceMotion = false;
    try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { reduceMotion = false; }
    var scanTimer = null;

    function clearOverlay() {
      if (!card) { return; }
      var old = card.querySelectorAll('.bt-scan, .bt-stamp');
      Array.prototype.forEach.call(old, function (n) { n.parentNode.removeChild(n); });
    }

    function showScan() {
      if (!card) { return; }
      clearOverlay();
      var o = document.createElement('div');
      o.className = 'bt-scan';
      o.innerHTML = '<span class="bt-scan-line"></span><span class="bt-scan-label">Verifying lot&hellip;</span>';
      card.appendChild(o);
    }

    /* Only ever stamped on a real match — see the note in brand-transparency.css. */
    function showStamp() {
      if (!card) { return; }
      var s = document.createElement('div');
      s.className = 'bt-stamp';
      s.textContent = '✓ VERIFIED';
      card.appendChild(s);
    }

    /* The card is the answer, not just the banner above it: looking a lot up
       swaps it to that lot's certificate, the way the prototype does. Only the
       fields we genuinely hold are rewritten — product name, lot number and the
       document link. The prototype also prints "Tested Jun 2026", which is not
       reproduced because certificate_of_analysis stores no date. */
    var nameEl = card && card.querySelector('[data-zpg-coa-name]');
    var metaEl = card && card.querySelector('[data-zpg-coa-meta]');
    var docEl = card && card.querySelector('[data-zpg-coa-doc]');
    /* The page's generic lab line, passed through explicitly. Deriving it from
       the meta text would inherit whatever lab the first card happened to name
       and then show it for lots that never named one. */
    var lab = metaEl ? (metaEl.getAttribute('data-zpg-lab') || '') : '';
    /* The verdict column and the badge belong to the product the card is
       showing, so a lookup that lands on another product has to move them too.
       A row carrying data-result-fixed states its own result and is left
       alone. */
    var badgeEl = card && card.querySelector('[data-zpg-coa-badge]');
    var resultEls = card ? Array.prototype.slice.call(card.querySelectorAll('[data-zpg-coa-result]')) : [];
    /* Idle the card is a description of the testing programme; on a match it
       becomes one lot's certificate. The kicker and the note say which of the
       two the reader is looking at, so both move with it. */
    var kickerEl = card && card.querySelector('[data-zpg-coa-kicker]');
    var noteEl = card && card.querySelector('[data-zpg-coa-note]');

    function setMode(isLot) {
      if (kickerEl) {
        var k = kickerEl.getAttribute(isLot ? 'data-kicker-lot' : 'data-kicker-idle');
        if (k) { kickerEl.textContent = k; }
      }
      if (noteEl) {
        var n = noteEl.getAttribute(isLot ? 'data-note-lot' : 'data-note-idle');
        if (n) { noteEl.textContent = n; }
      }
      resultEls.forEach(function (el) { el.hidden = !isLot; });
    }
    var original = {
      name: nameEl ? nameEl.textContent : '',
      meta: metaEl ? metaEl.textContent.replace(/\s+/g, ' ').trim() : '',
      doc: docEl ? docEl.getAttribute('href') : null,
      badge: badgeEl ? badgeEl.textContent.trim() : '',
      results: resultEls.map(function (el) { return el.textContent.trim(); })
    };

    function setVerdict(pass) {
      if (badgeEl) {
        var attr = pass ? 'data-badge-pass' : 'data-badge-plain';
        var text = badgeEl.getAttribute(attr);
        if (text) { badgeEl.textContent = text; }
      }
      resultEls.forEach(function (el) {
        var fixed = el.getAttribute('data-result-fixed');
        el.textContent = fixed ? fixed : (pass ? 'Pass' : 'Tested');
      });
    }

    function showLot(hit) {
      if (nameEl) { nameEl.textContent = hit.title; }
      if (metaEl) {
        /* "Lot X · Tested Jun 2026 · Eurofins" — each clause only when the
           certificate carries it. Falls back to the page's generic lab line. */
        var bits = ['Lot ' + hit.lot];
        if (hit.date) { bits.push('Tested ' + hit.date); }
        bits.push(hit.lab || lab);
        metaEl.textContent = bits.filter(Boolean).join(' · ');
      }
      if (docEl && hit.document && /^https:\/\//i.test(hit.document)) {
        docEl.setAttribute('href', hit.document);
        docEl.hidden = false;
      }
      /* Badge and verdicts are claims about a specific lot, so they stay out of
         the card until one is on screen. */
      if (badgeEl) { badgeEl.hidden = false; }
      setMode(true);
      setVerdict(hit.pass === true);
    }

    function restoreCard() {
      if (nameEl) { nameEl.textContent = original.name; }
      if (metaEl) { metaEl.textContent = original.meta; }
      if (docEl) {
        if (original.doc) { docEl.setAttribute('href', original.doc); }
        else { docEl.removeAttribute('href'); }
        docEl.hidden = true;
      }
      if (badgeEl) {
        if (original.badge) { badgeEl.textContent = original.badge; }
        badgeEl.hidden = true;
      }
      resultEls.forEach(function (el, i) {
        if (original.results[i] !== undefined) { el.textContent = original.results[i]; }
      });
      setMode(false);
    }

    /* ----- The certificate list follows the search -----
       Idle, the list shows the lot shipping today for every product. Once a
       lot is looked up it becomes the answer to that question and shows the
       matches only. Archive lots are not in the page markup at all, so a match
       on an older bottle is rebuilt here from the lookup index — otherwise
       searching a lot the page never printed would empty the list instead of
       showing the certificate the customer came for. */
    var library = root.querySelector('.bt-library');
    var staticGroups = library ? Array.prototype.slice.call(library.querySelectorAll('.bt-group')) : [];
    var promptEl = library && library.querySelector('[data-zpg-lot-prompt]');
    var footnoteEl = library && library.querySelector('.bt-footnote');
    /* Reuse the icon already in the markup rather than keeping a second copy
       of the SVG in here that can drift from the Liquid one. */
    var iconEl = library && library.querySelector('.bt-doc-icon');
    var iconHtml = iconEl ? iconEl.outerHTML : '';
    var resultsEl = null;

    function dropResults() {
      if (resultsEl && resultsEl.parentNode) { resultsEl.parentNode.removeChild(resultsEl); }
      resultsEl = null;
    }

    /* Resting state: the prompt, no certificates. The server-rendered list is
       hidden rather than removed so it still exists for a reader without
       JavaScript. */
    function showPrompt() {
      if (!library) { return; }
      dropResults();
      staticGroups.forEach(function (g) { g.hidden = true; });
      if (promptEl) { promptEl.hidden = false; }
      library.classList.remove('is-filtered');
    }

    /* A hit on one lot opens that product's whole shelf: the lot shipping now
       plus every earlier lot on file. Someone who searched the number on a
       two-year-old bottle is usually checking what they have against what is
       current, and making them run a second search to see it is busywork. */
    function expandToProducts(hits) {
      var wanted = {}, order = [];
      hits.forEach(function (h) {
        if (!wanted[h.title]) { wanted[h.title] = true; order.push(h.title); }
      });
      var matched = {};
      hits.forEach(function (h) { matched[h.title + '~' + h.lot] = true; });

      var byTitle = {};
      order.forEach(function (t) { byTitle[t] = []; });
      lots.forEach(function (l) {
        if (!wanted[l.title]) { return; }
        if (!l.document || !/^https:\/\//i.test(l.document)) { return; }
        byTitle[l.title].push(l);
      });
      order.forEach(function (t) {
        byTitle[t].sort(function (a, b) { return (b.current ? 1 : 0) - (a.current ? 1 : 0); });
      });
      return { order: order, byTitle: byTitle, matched: matched };
    }

    function filterLibrary(hits) {
      if (!library) { return; }
      dropResults();
      staticGroups.forEach(function (g) { g.hidden = true; });
      if (promptEl) { promptEl.hidden = true; }
      library.classList.add('is-filtered');

      var g = expandToProducts(hits);
      var html = g.order.map(function (title) {
        var rows = g.byTitle[title].map(function (l) {
          var isMatch = g.matched[title + '~' + l.lot];
          return '<li><a class="bt-doc' + (isMatch ? ' is-match' : '') + '" href="' + escapeHtml(l.document) + '" target="_blank" rel="noopener">'
            + iconHtml
            + '<span class="bt-doc-copy">'
            + '<span class="bt-doc-label">' + escapeHtml(String(l.lot).trim())
            + (isMatch ? ' <span class="bt-result-tag">your search</span>' : '') + '</span>'
            + '<span class="bt-doc-caption">' + (l.current === false ? 'Earlier lot' : 'Current lot')
            + ' <span aria-hidden="true">&middot;</span> View document'
            + '<span class="visually-hidden"> (opens in a new tab)</span></span>'
            + '</span><span class="bt-doc-arrow" aria-hidden="true">&nearr;</span></a></li>';
        }).join('');
        return '<div class="bt-group"><h3 class="bt-group-title">' + escapeHtml(title) + '</h3>'
          + '<ul class="bt-docs" role="list">' + rows + '</ul></div>';
      }).join('');

      resultsEl = document.createElement('div');
      resultsEl.setAttribute('data-zpg-lot-results', '');
      resultsEl.innerHTML = html;
      if (footnoteEl) { library.insertBefore(resultsEl, footnoteEl); }
      else { library.appendChild(resultsEl); }
    }

    /* Swap to the prompt as soon as the script runs, so the list is never on
       screen in the resting state for anyone who can search. */
    showPrompt();

    /* Lots are filed the way the lab writes them — "C052521 / ZMTI06 180ct",
       "C042624, C052601, C052602 / ZMTI10-12" — but the number printed on a
       bottle is one piece of that. Exact match alone meant a customer typing
       ZMTI06, which is what they are holding, got told their lot does not
       exist. So: strip everything that isn't a letter or digit from both
       sides, then match on containment. Exact hits still sort first. */
    function norm(s) { return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]/g, ''); }

    function findHits(raw) {
      var q = norm(raw);
      if (!q) { return []; }
      var exact = lots.filter(function (lot) { return norm(lot.lot) === q || norm(lot.code) === q; });
      if (exact.length) { return exact; }
      /* One or two characters would "match" most of the catalogue, which is
         noise dressed up as a result. */
      if (q.length < 3) { return []; }
      return lots.filter(function (lot) {
        return norm(lot.lot).indexOf(q) !== -1 || norm(lot.code).indexOf(q) !== -1 || norm(lot.title).indexOf(q) !== -1;
      });
    }

    function render() {
      out.classList.remove('is-hit', 'is-miss');
      clearOverlay();
      if (!input.value.trim()) { out.textContent = ''; restoreCard(); showPrompt(); return; }

      var hits = findHits(input.value);
      /* Current lots first: someone searching a product name should see what
         is shipping now before the lots that preceded it. Sorted before the
         list is built so both the banner and the cards below use this order. */
      hits.sort(function (a, b) { return (b.current ? 1 : 0) - (a.current ? 1 : 0); });
      /* A miss narrows the list to nothing on purpose. Putting every product
         back would read as "the search did nothing"; the miss message above
         says what happened. */
      filterLibrary(hits);
      if (hits.length) {
        out.classList.add('is-hit');
        var shown = hits.slice(0, 8);
        out.innerHTML = shown.map(function (hit) {
          return '<p>Lot ' + escapeHtml(hit.lot) + ' &middot; ' + escapeHtml(hit.title)
            + (hit.current === false ? ' <span class="bt-result-tag">earlier lot</span>' : '')
            + (hit.document && /^https:\/\//i.test(hit.document) ? '. <a href="' + escapeHtml(hit.document) + '" target="_blank" rel="noopener">View certificate</a>.' : '.') + '</p>';
        }).join('') + (hits.length > shown.length
          ? '<p>' + (hits.length - shown.length) + ' more match. Type more of the number to narrow it down.</p>'
          : '');
        showLot(hits[0]);
        showStamp();
      } else {
        restoreCard();
        out.classList.add('is-miss');
        out.textContent = lots.length
          ? 'No published lot matches "' + input.value.trim() + '". Check the number on the bottle, or email us and we will send that lot’s certificate.'
          : 'Lot numbers are published per product as each certificate is released. Email us with the number on your bottle and we will send its certificate.';
      }
    }

    /* Look up = scan, then answer. The pause is the prototype's, and it also
       stops the result flashing in and out while someone retypes. */
    function run() {
      clearTimeout(scanTimer);
      if (!input.value.trim() || reduceMotion || !card) { clearOverlay(); render(); return; }
      out.classList.remove('is-hit', 'is-miss');
      out.textContent = '';
      showScan();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      scanTimer = setTimeout(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        render();
      }, SCAN_MS);
    }

    btn.addEventListener('click', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(); }
    });
    /* Editing the query invalidates the previous verdict, so drop the stamp
       rather than leave it sitting over a lot that is no longer being asked
       about. */
    input.addEventListener('input', function () {
      clearTimeout(scanTimer);
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      clearOverlay();
      restoreCard();
      out.classList.remove('is-hit', 'is-miss');
      out.textContent = '';
      /* Emptying the box (including the search input's own clear button) puts
         the full current-lot list back. A half-typed query keeps the previous
         filtered list rather than flashing the whole catalogue back in on
         every keystroke. */
      if (!input.value.trim()) { showPrompt(); }
    });

    var chips = root.querySelectorAll('[data-zpg-lot-chip]');
    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-zpg-lot-chip') || '';
        run();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Build your own protocol. Real variants, real /cart/add.js.
     The discount is only ever mentioned when a real code is configured on the
     section; the code is applied by routing through /discount/<code> so
     checkout actually honors what the tray showed.
     --------------------------------------------------------------------- */
  function initBuilder(root) {
    var wrap = root.querySelector('[data-zpg-builder]');
    if (!wrap) { return; }

    var cards = wrap.querySelectorAll('[data-zpg-item]');
    if (!cards.length) { return; }

    var minQty = parseInt(wrap.getAttribute('data-min'), 10) || 3;
    var pct = parseInt(wrap.getAttribute('data-pct'), 10) || 0;
    var code = (wrap.getAttribute('data-code') || '').trim();
    var moneyFormat = wrap.getAttribute('data-money-format') || '${{amount}}';
    var hasDiscount = !!code && pct > 0;

    var emptyEl = wrap.querySelector('[data-zpg-tray-empty]');
    var bodyEl = wrap.querySelector('[data-zpg-tray-body]');
    var linesEl = wrap.querySelector('[data-zpg-tray-lines]');
    var subEl = wrap.querySelector('[data-zpg-subtotal]');
    var saveRow = wrap.querySelector('[data-zpg-saverow]');
    var saveEl = wrap.querySelector('[data-zpg-save]');
    var totalEl = wrap.querySelector('[data-zpg-total]');
    var nudgeEl = wrap.querySelector('[data-zpg-nudge]');
    var checkoutBtn = wrap.querySelector('[data-zpg-checkout]');

    /* vid -> { qty, price, name } */
    var picked = {};

    function money(c) { return formatMoney(c, moneyFormat); }

    function render() {
      var ids = Object.keys(picked);
      var units = 0;
      var subtotal = 0;

      if (linesEl) { linesEl.innerHTML = ''; }
      ids.forEach(function (id) {
        var it = picked[id];
        units += it.qty;
        subtotal += it.qty * it.price;
        if (!linesEl) { return; }
        var row = document.createElement('div');
        row.className = 'zpg-tray-line';
        var left = document.createElement('span');
        left.textContent = it.name;
        var x = document.createElement('span');
        x.className = 'zpg-x';
        x.textContent = ' × ' + it.qty;
        left.appendChild(x);
        var right = document.createElement('b');
        right.textContent = money(it.qty * it.price);
        row.appendChild(left);
        row.appendChild(right);
        linesEl.appendChild(row);
      });

      var any = ids.length > 0;
      if (emptyEl) { emptyEl.hidden = any; }
      if (bodyEl) { bodyEl.hidden = !any; }
      if (!any) { syncCards(); return; }

      /* Bundle pricing qualifies on distinct formulas picked, not total units —
         3× of one formula does not unlock it, matching the prototype. */
      var qualifies = hasDiscount && ids.length >= minQty;
      var saving = qualifies ? Math.round(subtotal * pct / 100) : 0;

      if (subEl) { subEl.textContent = money(subtotal); }
      if (saveRow) { saveRow.hidden = !qualifies; }
      if (saveEl) { saveEl.textContent = '−' + money(saving); }
      if (totalEl) { totalEl.textContent = money(subtotal - saving); }

      if (nudgeEl) {
        if (hasDiscount && ids.length < minQty) {
          var need = minQty - ids.length;
          nudgeEl.hidden = false;
          nudgeEl.textContent = 'Add ' + need + ' more formula' + (need === 1 ? '' : 's')
            + ' to save ' + pct + '%.';
        } else {
          nudgeEl.hidden = true;
        }
      }

      syncCards();
    }

    function syncCards() {
      Array.prototype.forEach.call(cards, function (card) {
        var id = card.getAttribute('data-vid');
        var it = picked[id];
        var addBtn = card.querySelector('[data-zpg-add]');
        var qtyBox = card.querySelector('[data-zpg-qty]');
        var nEl = card.querySelector('[data-zpg-n]');
        var on = !!it;
        card.classList.toggle('is-selected', on);
        if (addBtn) { addBtn.hidden = on; }
        if (qtyBox) { qtyBox.hidden = !on; }
        if (nEl && it) { nEl.textContent = it.qty; }
      });
    }

    function bump(card, delta) {
      var id = card.getAttribute('data-vid');
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var name = card.getAttribute('data-name') || '';
      var cur = picked[id] ? picked[id].qty : 0;
      var next = cur + delta;
      if (next <= 0) { delete picked[id]; }
      else { picked[id] = { qty: next, price: price, name: name }; }
      render();
    }

    Array.prototype.forEach.call(cards, function (card) {
      var addBtn = card.querySelector('[data-zpg-add]');
      var inc = card.querySelector('[data-zpg-inc]');
      var dec = card.querySelector('[data-zpg-dec]');
      if (addBtn) { addBtn.addEventListener('click', function () { bump(card, 1); }); }
      if (inc) { inc.addEventListener('click', function () { bump(card, 1); }); }
      if (dec) { dec.addEventListener('click', function () { bump(card, -1); }); }
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        var ids = Object.keys(picked);
        if (!ids.length) { return; }

        var items = ids.map(function (id) {
          return { id: parseInt(id, 10), quantity: picked[id].qty };
        });
        var units = ids.reduce(function (a, id) { return a + picked[id].qty; }, 0);

        checkoutBtn.disabled = true;
        var original = checkoutBtn.textContent;
        checkoutBtn.textContent = 'Adding…';

        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) { throw new Error('add failed'); }
            return res.json();
          })
          .then(function () {
            var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            if (hasDiscount && units >= minQty) {
              window.location.href = ((window.Shopify && Shopify.routes.root) || '/') + 'discount/' + encodeURIComponent(code)
                + '?redirect=' + encodeURIComponent(cartUrl);
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function () {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = original;
            if (nudgeEl) {
              nudgeEl.hidden = false;
              nudgeEl.textContent = 'Something went wrong adding those. Please try again.';
            }
          });
      });
    }

    render();
  }
})();
